







































































import { defineComponent, reactive, toRefs, PropType, computed, ref, watch } from '@vue/composition-api';
import CutImageArea from "../components/CutImageArea.vue";
import { PageItem, DirectionEnum, SheetField, KaitouModeEnum, AnswerText, StudentSheetStatusEnum, CorrectStateEnum } from "../modules/digital_paper/AnswerInput"

export interface Data {
  inputScale: number
  iconSize: number
  isDispIcon: boolean
  baseDistance: number
  baseScale: number
  pinchOffsetX: number
  pinchOffsetY: number
  pinchMarginX: number
  pinchMarginY: number
  touchLength: number
  KaitouModeEnum: Readonly<{None: number; Text: number; FreeLine: number; StraightLine: number; Eraser: number; Delete: number;}>
  StudentSheetStatusEnum: Readonly<{Answering: number; SelfScoring: number; Completed: number;}>
  CorrectStateEnum: Readonly<{Seitou: number; Gotou: number; Tokuten: number}>
}

export default defineComponent({
  props: {
    pageItems: {
      type: Array as PropType<PageItem[]>,
      required: true
    },
    height: {
      type: Number as PropType<number>,
      required: true
    },
    selectedPageIdx: {
      type: Number as PropType<number>,
      required: true
    },
    selectedFieldIdx: {
      type: Number as PropType<number>,
      required: false,
      default: null
    },
    selectedSheetField: {
      type: SheetField || null as PropType<SheetField | null>,
      required: false,
      default: null
    },
    selectedAnswerText: {
      type: AnswerText || null as PropType<AnswerText | null>,
      required: false,
      default: null,
    },
    kaitouMode: {
      type: Number as PropType<number>,
      required: true
    },
    direction: {
      type: Number as PropType<number>,
      required: true
    },
    fontSize: {
      type: Number as PropType<number>,
      required: true
    },
    lineHeight: {
      type: Number as PropType<number>,
      required: true
    },
    keyCode: {
      type: String as PropType<string>,
      required: false,
      default: null
    },
    cutMargin: {
      type: Number as PropType<number>,
      required: true
    },
    isTimeOver: {
      type: Boolean as PropType<boolean>,
      required: true
    },
    testPeriod: {
      type: String as PropType<string>,
      required: true
    },
    status: {
      type: Number as PropType<number>,
      required: true
    },
    drawColor: {
      type: String as PropType<string>,
      required: false,
      default: null
    },
    thickness: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  components: {
    "cut-image-area": CutImageArea,
  },
  setup (props, context) {

    const cutImageAreaRef = ref([]);

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      inputScale: 70,
      iconSize: 30,
      isDispIcon: true,
      baseDistance: 0,
      baseScale: 0,
      pinchOffsetX: 0,
      pinchOffsetY: 0,
      pinchMarginX: 0,
      pinchMarginY: 0,
      touchLength: 0,
      KaitouModeEnum: KaitouModeEnum,
      StudentSheetStatusEnum: StudentSheetStatusEnum,
      CorrectStateEnum: CorrectStateEnum,
    });

    /************************************************************
     * 表示中のpageItem
     ************************************************************/

    const selectedPageItem = computed((): any => {
      return props.pageItems[props.selectedPageIdx];
    });

    /************************************************************
     * 切り出しコンポーネントkeyの接頭辞
     ************************************************************/

    const cutAreaKeyPrefix = computed((): any => {
      return props.direction == DirectionEnum.Horizon ? "cut-area-h-" : "cut-area-v-";
    });

    /************************************************************
     * 表示領域の高さ
     ************************************************************/

    const areaHeightStyle = computed((): any => {
      const style: any = {};
      const margin = props.direction == DirectionEnum.Horizon ? 56 : 49;
      style["height"] = `${props.height - margin}px`;
      return style;
    });
    
    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const imageWrapStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${selectedPageItem.value.base_width * scale.value}px`;
      style["height"] = `${selectedPageItem.value.base_height * scale.value}px`;
      return style;
    });

    /************************************************************
     * 設問アイコンクリック
     ************************************************************/

    const changeSelectedSheetField = (idx: number) => {
      if(props.selectedFieldIdx == idx){
        context.emit("change-selected-base-sheet-field", null);
      }else{
        context.emit("change-selected-base-sheet-field", idx);
      }
    }

    /************************************************************
     * スライダーの値を倍率に変換
     ************************************************************/

    const scale = computed((): any => {
      return Number(state.inputScale) / 100;
    });

    /************************************************************
     * 解答済み設問か判定
     ************************************************************/

    const isKaitouCompleted = (sheetField: SheetField) => {
      return sheetField.isKaitouCompleted;
    }

    /************************************************************
     * ページ切り替え
     ************************************************************/

    const pageChanged = (idx: number) => {
      context.emit("answer-sheet-page-changed", idx);
    }

    /************************************************************
     * 切り出しエリアにCanvas描画 親から呼ばれる
     ************************************************************/

    const renderCanvas = () => {
      cutImageAreaRef.value.forEach((x: InstanceType<typeof CutImageArea>) => {
        x.renderCanvas();
      });
    }

    /************************************************************
     * 選択設問領域外をクリック
     * 設問の選択解除・テキストスタンプ選択解除
     ************************************************************/

    const fieldClicked = () => {
      changeSelectedSheetField(null);
      changeSelectedAnswerText(null);
    }

    /************************************************************
     * 選択中のテキストスタンプ切り替え
     ************************************************************/

    const changeSelectedAnswerText = (answerText: AnswerText) => {
      context.emit("change-selected-answer-text", answerText);
    }

    /************************************************************
     * テキストスタンプ追加 切り出しコンポーネントから呼ばれる
     ************************************************************/

    const addAnswerText = (answerText: AnswerText) => {
      context.emit("add-answer-text", answerText);
    }

    /************************************************************
     * テキストスタンプ削除 切り出しコンポーネントから呼ばれる
     ************************************************************/

    const deleteAnswerText = (answerText: AnswerText) => {
      context.emit("delete-answer-text", answerText);
    }

    /************************************************************
     * ショートカットキー＋マウスダウンによる解答モード変更
     * 切り出しコンポーネントから呼ばれる
     ************************************************************/

    const changeKaitouModeFromChild = (kaitouMode: number) => {
      context.emit("change-kaitou-mode-from-child", kaitouMode);
    }

    /************************************************************
     * 画像上をtouchstart
     ************************************************************/

    const imageAreaTouchstart = (e: TouchEvent) => {
      state.touchLength = e.touches.length;
    }

    /************************************************************
     * ピンチによる拡大縮小
     ************************************************************/

    const imageAreaTouchmove = (e: TouchEvent) => {

      state.touchLength = e.touches.length;

      if(e.touches.length > 1){
        
        e.preventDefault();

        const touches = e.touches;

        const x1 = touches[0].screenX;
        const y1 = touches[0].screenY;

        const x2 = touches[1].screenX;
        const y2 = touches[1].screenY;

        const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        
        if(state.baseDistance){
          const addScale = distance - state.baseDistance;
          
          // 値が低いほど早く拡大縮小する
          const pinchSpeed = 3;

          const newScale = state.baseScale + addScale / pinchSpeed;
          
          if(newScale >= 10 && newScale <= 200){
            state.inputScale = newScale;

            const offsetX = state.pinchOffsetX * scale.value;
            const offsetY = state.pinchOffsetY * scale.value;

            const pageRoot = document.getElementById(`answer-page-root-${props.direction}`);
            pageRoot.scrollLeft = offsetX - state.pinchMarginX;
            pageRoot.scrollTop = offsetY - state.pinchMarginY;
          }
          
        }else{
          state.baseDistance = distance;
          state.baseScale = Number(state.inputScale);
          
          const offsetXs = [];
          const offsetYs = [];

          for(let i = 0; i < 2; i++){
            const touch = e.touches[i];
            const touchElement = touch.target as HTMLElement;
            const bounds = touchElement.getBoundingClientRect();
            
            if(touchElement.id.includes("canvas")){
              // タッチしている要素が切り出しcanvasの場合
              const parentDiv = document.getElementById(touchElement.id.replace("canvas", "parent"));
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left + parseInt(parentDiv.style.left));
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top + parseInt(parentDiv.style.top));
            }else if(touchElement.id.includes("pencil")){
              // タッチしている要素が設問ペンシルの場合
              const parentDiv = document.getElementById(touchElement.id.replace("pencil", "pencil-parent"));
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left + parseInt(parentDiv.style.left));
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top + parseInt(parentDiv.style.top));
            }else if(touchElement.localName == "path"){
              // タッチしている要素が設問ペンシルSVGのpath要素の場合
              const pencilId = touchElement.parentElement.id;
              const parentDiv = document.getElementById(pencilId.replace("pencil", "pencil-parent"));
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left + parseInt(parentDiv.style.left));
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top + parseInt(parentDiv.style.top));
            }else if(touchElement.id.includes("text-image")){
              // タッチしている要素がテキストスタンプの場合
              const imageParentDiv = touchElement.parentElement;
              const cutAreaDiv = imageParentDiv.parentElement;
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left + parseInt(imageParentDiv.style.left) + parseInt(cutAreaDiv.style.left));
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top + parseInt(imageParentDiv.style.top) + parseInt(cutAreaDiv.style.left));
            }else{
              // 上記以外 答案用紙divの場合
              const bounds = touchElement.getBoundingClientRect();
              offsetXs.push(touch.clientX - window.pageXOffset - bounds.left) 
              offsetYs.push(touch.clientY - window.pageYOffset - bounds.top)
            }
          }

          // 解答用紙原寸大換算のピンチ中心座標取得
          const offsetX1 = offsetXs[0] > offsetXs[1] ? offsetXs[1] : offsetXs[0];
          const offsetX2 = offsetXs[0] > offsetXs[1] ? offsetXs[0] : offsetXs[1];
          const offsetY1 = offsetYs[0] > offsetYs[1] ? offsetYs[1] : offsetYs[0];
          const offsetY2 = offsetYs[0] > offsetYs[1] ? offsetYs[0] : offsetYs[1];
          const offsetX = offsetX1 + ((offsetX2 - offsetX1) / 2);
          const offsetY = offsetY1 + ((offsetY2 - offsetY1) / 2);
          state.pinchOffsetX = offsetX / scale.value;
          state.pinchOffsetY = offsetY / scale.value;

          const rootDiv = document.getElementById(`answer-page-root-${props.direction}`);
          state.pinchMarginX = offsetX - rootDiv.scrollLeft;
          state.pinchMarginY = offsetY - rootDiv.scrollTop;
        }
      }
    }

    /************************************************************
     * 画像上をtouchend
     ************************************************************/

    const imageAreaTouchend = (e: TouchEvent) => {
      state.baseDistance = 0;
      state.touchLength = e.touches.length;
    }

    /******************************
     * 倍率スライダー
     ******************************/

    watch(() => state.inputScale, (newVal, oldVal) => {

      if(state.touchLength == 0){
        const pageRoot = document.getElementById(`answer-page-root-${props.direction}`);
        const baseOffsetX = (pageRoot.scrollLeft + (pageRoot.offsetWidth / 2)) / (oldVal / 100);
        const baseOffsetY = (pageRoot.scrollTop + (pageRoot.offsetHeight / 2)) / (oldVal / 100);
        const centerX = pageRoot.offsetWidth / 2;
        const centerY = pageRoot.offsetHeight / 2;

        const newOffsetX = baseOffsetX * (Number(newVal) / 100);
        const newOffsetY = baseOffsetY * (Number(newVal) / 100);

        pageRoot.scrollLeft = newOffsetX - centerX;
        pageRoot.scrollTop = newOffsetY - centerY;
      }
    });

    /******************************
     * マウスホイール拡大縮小
     ******************************/

    const imageAreaMousewheel = (e: WheelEvent) => {
      if(props.keyCode == "Control" || e.ctrlKey){
        e.preventDefault();
        const newScale = state.inputScale - (e.deltaY / 30);
        if(newScale >= 10 && newScale <= 200){
          state.inputScale = newScale;
        }
      }
    }

    return {
      ...toRefs(state),
      cutImageAreaRef,
      selectedPageItem,
      cutAreaKeyPrefix,
      areaHeightStyle,
      imageWrapStyle,
      scale,
      changeSelectedSheetField,
      isKaitouCompleted,
      pageChanged,
      renderCanvas,
      changeSelectedAnswerText,
      deleteAnswerText,
      addAnswerText,
      fieldClicked,
      changeKaitouModeFromChild,
      imageAreaTouchstart,
      imageAreaTouchmove,
      imageAreaTouchend,
      imageAreaMousewheel,
    }
  }
});
